import { useEffect, useState } from 'react';

import { useUserContext } from '../utils/contexts/UserContext';

export const useHubSpotChat = ({ enable }) => {
    const [isChatOpen, setIsChatOpen] = useState(false);
    const { user } = useUserContext();

    const updateChatPosition = (isOpen) => {
        const existingStyles = document.querySelectorAll('style[data-hubspot-chat-position]');
        existingStyles.forEach((style) => style.remove());
        const style = document.createElement('style');
        style.setAttribute('data-hubspot-chat-position', 'true');
        const displayValue = isOpen ? 'block' : 'none';
        style.innerHTML = `
            .widget-align-right#hubspot-messages-iframe-container {
                display: ${displayValue} !important;
                left: 218px !important;
                .hs-drag-handle.hs-drag-handle--right {
                    display: none !important;
                    visibility: hidden !important;
                    opacity: 0 !important;
                    pointer-events: none !important;
                }
            }

            .hubspot-chat-close-button {
                position: absolute;
                top: 10px;
                right: 10px;
                width: 24px;
                height: 24px;
                background: #ff4444;
                border: none;
                border-radius: 50%;
                color: white;
                font-size: 16px;
                font-weight: bold;
                cursor: pointer;
                z-index: 9999;
                display: flex;
                align-items: center;
                justify-content: center;
                box-shadow: 0 2px 4px rgba(0,0,0,0.2);
                padding-bottom: 2px;
            }

            .hubspot-chat-close-button:hover {
                background: #ff0000;
                transform: scale(1.1);
            }
        `;
        document.head.appendChild(style);
    };

    useEffect(() => {
        if (!enable) return;

        if (document.getElementById('hs-script-loader')) return;

        if (user?.email) {
            window._hsq = window._hsq || [];
            window._hsq.push([
                'identify',
                {
                    id: user.id,
                    email: user.email,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    company: user.customer?.company || user.logisticProvider?.company || '',
                },
            ]);
        }

        const script = document.createElement('script');
        script.src = '//js.hs-scripts.com/7501784.js';
        script.id = 'hs-script-loader';
        script.async = true;
        script.defer = true;

        document.head.appendChild(script);

        const hideChatLauncherAndDragHandle = () => {
            updateChatPosition(false);
        };

        const poll = setInterval(() => {
            if (window.HubSpotConversations && window.HubSpotConversations.widget) {
                window.HubSpotConversations.widget.load();
                hideChatLauncherAndDragHandle();

                setTimeout(() => {
                    if (window.HubSpotConversations?.widget) {
                        window.HubSpotConversations.widget.close();
                        setIsChatOpen(false);
                        removeCloseButton();
                    }
                }, 100);
                clearInterval(poll);
            }
        }, 300);

        return () => {
            clearInterval(poll);
        };
    }, [
        enable,
        user.customer?.company,
        user.email,
        user.firstName,
        user.id,
        user.lastName,
        user.logisticProvider?.company,
    ]);

    const addCloseButton = () => {
        const chatContainer = document.querySelector('#hubspot-messages-iframe-container');
        if (chatContainer) {
            const existingButton = chatContainer.querySelector('.hubspot-chat-close-button');
            if (existingButton) {
                existingButton.remove();
            }

            const closeButton = document.createElement('button');
            closeButton.className = 'hubspot-chat-close-button';
            closeButton.innerHTML = '×';
            closeButton.title = 'Fermer le chat';
            closeButton.onclick = () => {
                if (window.HubSpotConversations?.widget) {
                    window.HubSpotConversations.widget.close();
                    setIsChatOpen(false);
                    updateChatPosition(false);
                    closeButton.remove();
                }
            };
            chatContainer.appendChild(closeButton);
        }
    };

    const toggleHubSpotChat = () => {
        if (!enable) {
            // eslint-disable-next-line no-console
            console.warn('HubSpot chat is disabled');
        }

        if (window.HubSpotConversations?.widget) {
            if (isChatOpen) {
                window.HubSpotConversations.widget.close();
                setIsChatOpen(false);
                updateChatPosition(false);
                removeCloseButton();
            } else {
                window.HubSpotConversations.widget.open();
                setIsChatOpen(true);
                setTimeout(() => {
                    updateChatPosition(true);
                }, 300);
                addCloseButton();
            }
        }
    };

    const removeCloseButton = () => {
        const closeButton = document.querySelector('.hubspot-chat-close-button');
        if (closeButton) {
            closeButton.remove();
        }
    };

    return { isChatOpen, toggleHubSpotChat, addCloseButton, removeCloseButton };
};
